<script>
import Vue from 'vue'

/**
 * A confirmation directive, which adds a confirmation message box to the onClick event. It adds an onClick listener event to the element, which displays a confirmation message dialog before executing desired action. It takes as parameters:
  onConfirm - a reference to the function, which is supposed to be executed after successful confirmation,
  modalController - a reference to a controller for a modal to use instead of `window.confirm`
  confirmHeader - an optional header to set (if modalController is supplied)
  confirmMessage - a message to be displayed in confirmation dialog
  negativeLabel - the label to show on the negative button
  positiveLabel - the label to show on the positive button
 *
 *
 * i.e.  <button type="button" class="ui icon red button" v-confirm-click="{ onConfirm: deleteApp, modalController: ctrl, confirmHeader: 'Are you sure', confirmMessage: 'Confirm it!' }"></button>

 *
 */
export default Vue.directive('confirm-click', {
  bind: function(el, binding, vnode) {
    el.addEventListener('click', function(event) {
      event.preventDefault()
      event.stopPropagation()
      const ctrl = binding.value.modalController
      if (ctrl) {
        if (binding.value.confirmHeader) ctrl.header = binding.value.confirmHeader
        ctrl.body = binding.value.confirmMessage
        ctrl.positiveLabel = binding.value.positiveLabel || ''
        ctrl.negativeLabel = binding.value.negativeLabel || ''
        ctrl
          .show()
          .then(binding.value.onConfirm)
          .catch()
      } else if (window.confirm(vnode.context.confirmMessage)) {
        binding.value.onConfirm()
      }
      return false
    })
  },

  componentUpdated: function(el, binding, vnode) {
    vnode.context.confirmMessage = binding.value.confirmMessage
  }
})
</script>
